export default "__VITE_ASSET__CQU$MZEs__"